import { KeyValue } from '@/main/models/common';
import { MappingTypeTypes, MappingTypeActionTypes } from './mappingTypeTypes';

export function getMappingType(): MappingTypeActionTypes {
  return {
    type: MappingTypeTypes.GET_MAPPING_TYPE
  };
}

export function saveMappingType(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): MappingTypeActionTypes {
  return {
    type: MappingTypeTypes.SAVE_MAPPING_TYPE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerMappingType(): MappingTypeActionTypes {
  return {
    type: MappingTypeTypes.RESET_REDUCER_MAPPING_TYPE
  };
}

